import React, { useState } from 'react';
import logo_close from '../assets/close-check.png';
import '../styles/Connexion.css';
import GoogleLoginButton from './GoogleLoginButton';
import FacebookLoginButton from './FacebookLoginButton';

function Connexion() {

    const [isformConnexion, setisformConnexion] = useState(false)
    const [emailValue, setEmailValue] = useState('')
    const [isDataRegistering, setIsDataRegistering] = useState(false)
    const [isConnexionMailSend, setisConnexionMailSend] = useState(false)
    const [isCompleted, setIsCompleted] = useState(false)
    const [isError, setError] = useState(false)
    const [tmpKey, setTmpKey] = useState('')

    if (tmpKey === '') {
        const timestamp = Date.now();
        setTmpKey(timestamp);
    }

    function handleInputMail(e) {
        setEmailValue(e.target.value)
    }

    async function requestConnexion() {
        if (isValidEmail(emailValue)) {
            sendConnexionMail(emailValue)
        }
        else {
            alert("Attention, ceci n'est pas une adresse valide 😥")
        }
    }

    async function sendConnexionMail(p_email) {

        console.log("registerReservation debut");
        const requestOptions = {
            method: "POST",
            mode: 'cors',
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({
                email: p_email
            }),
        };

        try {
            let v_responseJson = {};
            console.log("tmpKey " + tmpKey);
            setIsDataRegistering(true)
            const response = await fetch("https://app.listaki.fr/api/WS/sendAccessLink.php?key=" + tmpKey, requestOptions)
            if (response.ok) {
                v_responseJson = await response.json();
                console.log("Reponse api debut");
                console.log(v_responseJson)
                console.log("Reponse api fin");
                if (v_responseJson["success"]) setisConnexionMailSend(true)
                else alert(v_responseJson["error"])
                setIsCompleted(true);
            } else {
                console.log("Erreur lors de l'appel à l'API");
                v_responseJson = await response.json();
                if (v_responseJson["error"]) alert(v_responseJson["error"])
                setError(true);
            }
        } catch (err) {
            console.log(err)
        } finally {
            setIsDataRegistering(false)
        }
    };

    function isValidEmail(p_email) {
        console.log(p_email);
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        return emailRegex.test(p_email);
    }
    function closeAll() {
        setisConnexionMailSend(false)
        setisformConnexion(false)
    }

    return !isConnexionMailSend & isformConnexion ? (
        
      <div className="ui-overlay">
            {/* <div className="ui-modal"> */}
        <div className='kdo-connexion-box'>
            <img src={logo_close} alt="Fermer" onClick={() => setisformConnexion(false)} className='kdo-logoclose' />
            <div>
                <p>Si vous avez un compte, saisissez votre email pour vous connecter</p>
                <p>Vous allez recevoir un email avec votre lien de connexion. Pensez à vérifier vos spam si vous ne le trouvez pas.</p>
                <p>
                    <input
                        className='kdo-reg-elem'
                        placeholder='Entrez votre mail'
                        onChange={handleInputMail}
                    />
                    <button className="kdo-button" onClick={() => {
                        if (window.umami) window.umami.track('login-mail-click');
                        requestConnexion();
                                            }}>Recevoir mon email de connexion.</button></p>
                    <p>Sinon utilisez un autre moyen de connexion</p>
                <div className="google-button-wrapper">
                    <GoogleLoginButton/>
                </div>
                <div className="fb-button">
                    <FacebookLoginButton />
                </div>
            </div>
        </div>
        </div>
    ) : isConnexionMailSend & isformConnexion ?
        (
            <div className="ui-overlay">
            <div className='kdo-connexion-box'>
                <img src={logo_close} alt="Fermer" onClick={() => closeAll()} className='kdo-logoclose' />
                <div>
                    <p>Si vous êtes inscrit, vous venez de recevoir un email avec votre lien de connexion. Pensez à vérifier vos spam si vous ne le trouvez pas.</p>
                </div>
            </div>
            </div>
        ) : (
            <p>Vous avez déjà un compte ? <a href="#" onClick={() => setisformConnexion(true)}>Se connecter</a></p>
        )
};

export default Connexion;